var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBubbleTip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35.23,
  height: 25.03,
  viewBox: "0 0 35.23 25.03",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "bubbleTip")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.72,0C13.72,9.51,8.28,25,0,25c19.05,0,30.07-8.15,35.23-25Z"
})))));
export default SvgBubbleTip;